// action - state management
import { LOGIN, LOGOUT, REGISTER, SETQRIMAGE, REQUIRESETPASSWORD, SESSION_TIMEOUT, SETUSER_NAME } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    qrImage: null,
    tempId: null,
    tempSecret: null,
    otpSessionKey: null,
    keepLogin: null
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user,
                isSessionTimeout: false
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                qrImage: null,
                tempId: null,
                tempSecret: null,
                isSessionTimeout: false
            };
        }

        case SETQRIMAGE: {
            return {
                ...state,
                qrImage: action.payload?.qrImage || null,
                tempId: action.payload.id,
                tempSecret: action.payload.tempSecret,
                initLogin: action.payload?.initLogin || false
            };
        }

        case REQUIRESETPASSWORD: {
            return {
                ...state,
                requireSetPassword: action.payload?.requireSetPassword || false
            };
        }

        case SESSION_TIMEOUT: {
            const { isSessionTimeout } = action.payload;
            return {
                ...state,
                isInitialized: true,
                isSessionTimeout
            };
        }

        // Set name.first and name.last
        case SETUSER_NAME: {
            const { name } = action.payload;
            return {
                ...state,
                user: {
                    ...state.user,
                    name: {
                        first: name.first,
                        last: name.last
                    }
                }
            };
        }

        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
